import { onMounted, onUnmounted, ref } from "@vue/composition-api";

type CountDownOptions = {
  immediate?: boolean;
};

export default function useCountDown(durationInSeconds: number, options?: CountDownOptions) {
  const timeLeft = ref(options?.immediate ? durationInSeconds : 0);
  let interval: ReturnType<typeof setInterval> | null;

  const stop = () => {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  };

  const start = () => {
    if (interval) return;
    if (timeLeft.value === 0) {
      timeLeft.value = durationInSeconds;
    }
    interval = setInterval(() => {
      timeLeft.value = timeLeft.value - 1;
      if (timeLeft.value === 0) {
        stop();
      }
    }, 1000);
  };
  const restart = () => {
    stop();
    timeLeft.value = 0;
    start();
  };

  if (options?.immediate) {
    onMounted(start);
  }

  onUnmounted(stop);

  return {
    timeLeft,
    start,
    stop,
    restart,
  };
}
